// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"suggestions_wrapper__W_ZNN","header":"suggestions_header__XubUJ","suggestions_wrapper":"suggestions_suggestions_wrapper__ZaxqX"};